import React from 'react';

type BadgeVariant =
  | 'active' |'expired' |'expiring' |'suspended' |'pending' |'paid' |'overdue' |'partial' |'confirmed' |'cancelled' |'no-show' |'completed' |'waived' |'prospect';

const variantStyles: Record<BadgeVariant, string> = {
  active: 'bg-success-bg text-success border-success/20',
  expired: 'bg-secondary text-muted-foreground border-border',
  expiring: 'bg-warning-bg text-warning border-warning/20',
  suspended: 'bg-danger-bg text-danger border-danger/20',
  pending: 'bg-info-bg text-info border-info/20',
  paid: 'bg-success-bg text-success border-success/20',
  overdue: 'bg-danger-bg text-danger border-danger/20',
  partial: 'bg-warning-bg text-warning border-warning/20',
  confirmed: 'bg-info-bg text-info border-info/20',
  cancelled: 'bg-secondary text-muted-foreground border-border',
  'no-show': 'bg-danger-bg text-danger border-danger/20',
  completed: 'bg-success-bg text-success border-success/20',
  waived: 'bg-secondary text-muted-foreground border-border',
  prospect: 'bg-secondary text-secondary-foreground border-border',
};

const variantLabels: Record<BadgeVariant, string> = {
  active: 'Active',
  expired: 'Expired',
  expiring: 'Expiring Soon',
  suspended: 'Suspended',
  pending: 'Pending',
  paid: 'Paid',
  overdue: 'Overdue',
  partial: 'Partial',
  confirmed: 'Confirmed',
  cancelled: 'Cancelled',
  'no-show': 'No-Show',
  completed: 'Completed',
  waived: 'Waived',
  prospect: 'Prospect',
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 border rounded-full font-medium whitespace-nowrap ${variantStyles[variant]} ${
        size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-[11px] px-2.5 py-0.5'
      }`}
    >
      <span className={`rounded-full flex-shrink-0 ${
        size === 'sm' ? 'w-1 h-1' : 'w-1.5 h-1.5'
      } ${variantStyles[variant].includes('success') ? 'bg-success' : variantStyles[variant].includes('warning') ? 'bg-warning' : variantStyles[variant].includes('danger') ? 'bg-danger' : variantStyles[variant].includes('info') ? 'bg-info' : 'bg-muted-foreground'}`} />
      {label ?? variantLabels[variant]}
    </span>
  );
}